
namespace Matrix.DataAudit {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SecurityHistoryDialog extends SiteEntityDialog<SecurityHistoryRow, any> {
        protected getFormKey() { return SecurityHistoryForm.formKey; }
        protected getIdProperty() { return SecurityHistoryRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityHistoryRow.localTextPrefix; }
        protected getNameProperty() { return SecurityHistoryRow.nameProperty; }
        protected getService() { return SecurityHistoryService.baseUrl; }

        protected form = new SecurityHistoryForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.element.hide();
            this.cloneButton.hide();
        }

        protected get hasPendingChanges() {
            return false;
        }
    }
}